import { render, staticRenderFns } from "./Modal.Message.vue?vue&type=template&id=0d6825e6&scoped=true&"
import script from "./Modal.Message.vue?vue&type=script&lang=js&"
export * from "./Modal.Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6825e6",
  null
  
)

export default component.exports